import { ho } from "apis/homeowner/ho";
import {
  REQUEST_CASE_LINKS,
  RECEIVE_CASE_LINKS,
  ERROR_RETRIEVING_CASE_LINKS,

  REQUEST_ALL_CASE_FORMS,
  RECEIVE_ALL_CASE_FORMS,
  ERROR_RETRIEVING_ALL_CASE_FORMS,

  REQUEST_POST_CASE_FORM,
  RECEIVE_POST_CASE_FORM,
  ERROR_RETRIEVING_POST_CASE_FORM,

  REQUEST_AVAILABLE_CASE_FORMS,
  RECEIVE_AVAILABLE_CASE_FORMS,
  ERROR_RETRIEVING_AVAILABLE_CASE_FORMS,

  REQUEST_DELETE_CASE_FORM,
  RECEIVE_DELETE_CASE_FORM,
  ERROR_RETRIEVING_DELETE_CASE_FORM,

  MANAGE_FORMS_DIALOG,
} from "typeConstants";
import { WebApiRequest, WebApiReduxRequest, WebApiReduxRequestWithCallback, HTTP_GET, HTTP_PUT, HTTP_DELETE, HTTP_POST } from "tools/webservice";

export const getCaseNotifications = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.getCaseNotifications(controlIdNumber),
  successCallback,
  mountedRef,
});

export const resendCaseNotification = (controlIdNumber, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: ho.getCaseNotifications(controlIdNumber),
  payload,
  successCallback,
  mountedRef,
});

export const stopResendCaseNotification = (controlIdNumber, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: ho.getCaseNotifications(controlIdNumber),
  payload,
  successCallback,
  mountedRef,
});

// This is also available as an action in redux
export const getCaseHazards = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.getCaseHazards(controlIdNumber),
  successCallback,
  mountedRef,
});

export const getCaseRecommendations = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.getCaseRecommendations(controlIdNumber),
  successCallback,
  mountedRef,
});

export const getPolicyInfo = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.policyInfo(controlIdNumber),
  successCallback,
  mountedRef,
});

export const getCaseLinksRedux = (controlIdNumber) => {
  return WebApiReduxRequest(
    REQUEST_CASE_LINKS,
    RECEIVE_CASE_LINKS,
    ERROR_RETRIEVING_CASE_LINKS,
    HTTP_GET,
    `/homeowner/cases/${controlIdNumber}/case-links`);
};

export const getCaseLinksLimitedRedux = (controlIdNumber) => {
  return WebApiReduxRequest(
    REQUEST_CASE_LINKS,
    RECEIVE_CASE_LINKS,
    ERROR_RETRIEVING_CASE_LINKS,
    HTTP_GET,
    `/homeowner/cases/${controlIdNumber}/case-links-limited`);
};

export const getAllCaseFormsRedux = (controlNumber) => {
  return WebApiReduxRequest(
    REQUEST_ALL_CASE_FORMS,
    RECEIVE_ALL_CASE_FORMS,
    ERROR_RETRIEVING_ALL_CASE_FORMS,
    HTTP_GET,
    `/homeowner/cases/${controlNumber}/case-forms/all`
  );
};
export const updateCaseForm = (controlNumber, payload, successCallback, mountedRef) => {
  return WebApiRequest({
    method: HTTP_PUT,
    endpoint: `/homeowner/cases/${controlNumber}/case-forms`,
    payload: payload,
    successCallback,
    mountedRef,
  });
};
export const deleteCaseForm = (controlNumber, payload, callback) => {
  return WebApiReduxRequestWithCallback(
    REQUEST_DELETE_CASE_FORM,
    RECEIVE_DELETE_CASE_FORM,
    ERROR_RETRIEVING_DELETE_CASE_FORM,
    HTTP_DELETE,
    `/homeowner/cases/${controlNumber}/case-forms`,
    callback,
    payload,
  );
};
export const addCaseFormRedux = (controlNumber, payload, callback) => {
  return WebApiReduxRequestWithCallback(
    REQUEST_POST_CASE_FORM,
    RECEIVE_POST_CASE_FORM,
    ERROR_RETRIEVING_POST_CASE_FORM,
    HTTP_POST,
    `/homeowner/cases/${controlNumber}/case-forms`,
    callback,
    payload,
  );
};
export const getAvailCaseFormsListRedux = (controlNumber) => {
  return WebApiReduxRequest(
    REQUEST_AVAILABLE_CASE_FORMS,
    RECEIVE_AVAILABLE_CASE_FORMS,
    ERROR_RETRIEVING_AVAILABLE_CASE_FORMS,
    HTTP_GET,
    `/availform/case/${controlNumber}`
  );
};
export const manageFormsRedux = (payload) => {
  return {
    type: MANAGE_FORMS_DIALOG,
    payload: payload,
  };
};

export const getCaseDistances = (startControlIdNumber, destinationControlIdNumbers, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: destinationControlIdNumbers,
  endpoint: `/homeowner/cases/${startControlIdNumber}/distances`,
  successCallback,
  mountedRef,
});

export const copyCase = (copyCaseRequest, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: copyCaseRequest,
  endpoint: ho.copyCase(),
  successCallback,
  errorCallback,
  mountedRef
});

export const copyCaseAsCustomer = (copyCaseRequest, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: copyCaseRequest,
  endpoint: ho.copyCaseAsCustomer(),
  successCallback,
  errorCallback,
  mountedRef
});
